import Net from '@/services/net'

export function markNotificationReadOrUnread(id: number, read = true) {
  let url = `/usernotifications/read`
  if (read) {
    url = `/usernotifications/unread`
  }
  return Net.t1.put(url, [{ Id: id }])
}
